module.exports = __webpack_public_path__ + "jpg/puzzle.jpg?6c315acf0088b5dd4ce5f5cb11d813f6";